export function calculateEMI(price) {
    const priceInRupees = parseFloat(price.replace(/,/g, ''));
    const downPayment = priceInRupees * 0.10;
    const loanAmount = priceInRupees - downPayment;
    const annualInterestRate = 23;
    const monthlyInterestRate = annualInterestRate / 100 / 12;
    const tenureMonths = 3 * 12;
    const emi = (loanAmount * monthlyInterestRate * Math.pow(1 + monthlyInterestRate, tenureMonths)) /
        (Math.pow(1 + monthlyInterestRate, tenureMonths) - 1);
    const emiRounded = emi.toFixed(0);
    return emiRounded;
}

export function calculateMontlyEMI(
  downpayment,
  tenure,
  interestRate = 22,
  price = 300000
) {
  if (tenure <= 0 || interestRate < 0 || price <= 0 || downpayment < 0) {
    return "Invalid input values";
  }
  const principal = price - downpayment;
  const monthlyRate = interestRate / 12 / 100;
  if (monthlyRate === 0) {
    return (principal / tenure).toFixed(2);
  }
  const emi =
    (principal * monthlyRate * Math.pow(1 + monthlyRate, tenure)) /
    (Math.pow(1 + monthlyRate, tenure) - 1);

  return emi.toFixed(2);
}
